export default {
  /* A */
  add: '추가',
  all: '전체',
  admin: '관리 화면',
  alias: '별명',
  apply: '적용',
  agent: '대리',
  agents: '대리',
  appKey: '사용자 이름',
  avatar: '아바타',
  amount: '금액',
  action: '동작',
  agentId: '대리',
  approve: '승인',
  activate: '활성화',
  autoSync: '자동 동기화',
  approval: '승인',
  approved: '승인됨',
  allCache: '모든 캐시',
  activated: '활성화됨',
  accountId: '거래 시스템 사용자 ID',
  appSecret: '비밀번호',
  agentName: '대리 이름',
  amountInfo: '금액 정보',
  addressInfo: '주소 정보',
  autoChannel: '자동',
  addressDetail: '상세 주소',
  accountAmount: '계정 금액',
  approvalStatus: '승인 상태',
  accountCurrency: '계정 통화',
  alreadyLoggedIn: '이미 로그인',
  approvalProcess: '승인 프로세스',
  accountActivate: '계정 활성화',
  accountActivated: '활성화 여부',
  appliedDate: '신청 일자',
  approvalComment: '승인 코멘트',
  approveAndWithdraw: '돈을 전달하고 인출하세요',
  alreadyHaveAccount: '이미 계정이 있습니까?',
  // accountRiskLevel: '계정 리스크 레벨',
  allSelectedCount: '전체 ({count})',
  actualAccountAmount: '실제 계정 금액',
  actualDepositAmount: '실제 입금 금액',
  accountDepositAmount: '거래 계정 입금 금액',
  accountWithdrawalAmount: '출금 금액',
  apiResultMsg: 'API 결과 메시지',
  android: 'Android',
  androidLink: 'Android Link',
  accountInfo: 'Account Info',

  /* B */
  back: '뒤로',
  bank: '은행',
  branch: '지점',
  backTo: '로그인으로 돌아가기',
  bankNo: '은행 번호',
  backTop: '맨 위로 돌아가기',
  balance: '잔액',
  bankCard: '은행 카드',
  bordered: '테두리',
  basicInfo: '기본 정보',
  batchSize: '수량',
  backToLogin: '로그인으로 돌아가기',
  backToPrevious: '이전으로 돌아가기',
  backToPreviousStep: '이전의',
  backToRegister: '등록으로 돌아가기',
  bankBranch: '개설 지점 이름',
  bankAccount: '은행 계좌',
  baseCurrency: '기본 화폐',
  branchAddress: '지점 주소',
  bankAccountName: '은행 계좌명',
  bankNameOrNetwork: '은행 이름 / 입금 네트워크',
  bankCardInfo: 'Bank Card Info',
  bankCardId: 'Bank Card ID',

  /* C */
  csv: 'CSV',
  copy: '복사',
  check: '확인',
  close: '닫기',
  cancel: '취소',
  create: '생성',
  confirm: '확인',
  checked: '선택됨',
  comment: '코멘트',
  countryOrRegion: '국가 / 지역',
  created: '생성됨',
  channel: '채널',
  closeAll: '모두 닫기',
  customer: '고객',
  copyLink: '링크 복사',
  countries: '국가',
  createdBy: '생성자',
  childType: '하위 유형',
  cancelDate: '취소 날짜',
  cardholder: '카드 소유자',
  customerId: '고객 ID',
  configName: '변수 이름',
  configDesc: '변수 설명',
  cardDetail: '카드 정보',
  conversion: '환산',
  cashflowKid: '거래 시스템 거래 ID',
  channelName: '채널 이름',
  configValue: '변수 값',
  createdDate: '생성 날짜',
  currencyType: '내외화 계좌 여부',
  channelError: '채널 오류',
  customerInfo: '고객 정보',
  customerData: '고객 데이터',
  currentCache: '현재 캐시',
  closeAllTabs: '모든 탭 닫기',
  createdBefore: '이전에 생성됨',
  cryptoNetwork: '암호화 통신망',
  clearAllCache: '모든 캐시 지우기',
  contactContent: '연락처 내용',
  forgotPassword: '비밀번호 잊어버림',
  changePassword: '비밀번호 변경',
  customerVerify: '고객 인증',
  closeOtherTabs: '다른 탭 닫기',
  closeRightTabs: '오른쪽 탭 닫기',
  createAccounts: '계정 생성',
  certificateNo: '인증서 번호',
  confirmationMin: '최소 확인 횟수',
  confirmPassword: '비밀번호 확인',
  closeCurrentTab: '현재 탭 닫기',
  chineseSimplified: '중국어 (간체)',
  changePwdSucceess: '비밀번호 변경 성공',
  customerFeeAmount: '고객 수수료 금액',
  customerCurrencies: '고객 화폐',
  customerDepositFlow: '고객 입금 흐름',
  customerVerifyFlowId: '현재 검증 ID',
  customerIdentificationId: '신분증 ID',
  cancelTransaction: '거래 취소',
  cancelTransactionPopupTitle: '이 작업은 취소할 수 없으며, 이 거래를 포기하시겠습니까?',
  captchaImageErrorMsg: '오류 발생, 클릭하여 새로 고침',
  captchaText: '인증 코드',
  completed: '완료',
  confirmDetail: '세부 확인',
  confirmProof: '확인 증명',
  confirmComplete: '완료 확인',
  confirmRecvPopupTitle: '이 작업은 취소할 수 없으므로 이 거래를 수신했는지 확인하십시오.',
  confirmTransaction: '거래 확인',
  confirmTransactionPopupTitle: '이 작업은 취소할 수 없으며 이 거래가 완료되었는지 확인하십시오?',
  currentChannelNotAvailableAndSetAsAuto: '현재 채널이 사용 불가능하며 자동으로 설정되었습니다.',

  /* D */
  dob: '생년월일',
  desc: '소개',
  detail: '상세 정보',
  details: '상세 정보',
  deposit: '입금',
  depositHistory: '충전 내역',
  download: '다운로드',
  demoSystem: '데모 시스템',
  demoAppKey: '데모 사용자 이름',
  description: '설명',
  demoAppSecret: '데모 비밀번호',
  depositAmount: '입금 금액',
  depositDetail: '입금 세부 정보',
  depositVerify: '입금 검토',
  depositRemark: '송금 메모',
  depositFlowId: '입금 ID',
  depositCurrency: '입금 화폐',
  depositApproval: '입금 승인',
  depositInfo: 'Deposit Info',

  /* E */
  en: '영어',
  env: '환경',
  edit: '편집',
  enum: '열거',
  empty: '비어있음',
  enable: '활성화',
  enabled: '활성화됨',
  existing: '기존',
  equalZero: '제로와 같음',
  expandAll: '모두 확장',
  emailDetail: '이메일',
  engFullName: '영문 전체 이름',
  engShortName: '영문 약식 이름',
  emailVerified: '이메일 인증',
  encryptedId: '업스트림 주문 번호',
  expectedWithdrawalAmount: '출금예정금액',
  exclusiveAccountId: 'Exclusive Account ID',

  /* F */
  fee: '수수료',
  force: '강제',
  fxRate: '환율 정보',
  failure: '실패',
  feeInfo: '수수료 정보',
  flowInfo: '플로우 정보',
  fullName: '성명',
  forceCancel: '강제 취소',
  familyNameEn: '영문 성',
  forceConfirm: '강제 확인',
  frozenAmount: '동결된 금액',
  fxCurrencyPair: '외환 화폐 쌍',
  fxRateTemplate: '환율 템플릿',
  fatcaSignedDate: 'FATCA 서명 날짜',
  fxRateTemplateId: '환율 템플릿 ID',
  forgotNoticeTitle1: '비밀번호 재설정 링크가 이메일로 전송되었습니다.',
  forgotNoticeTitle2: '이메일로 로그인하여 비밀번호를 재설정하세요!',
  forgotNoticeTitle3: '이미 이메일에 로그인하고 링크를 클릭하셨나요?',

  /* G */
  goRegister: '지금 등록하기',
  gotoVerify: '인증하러 가기',
  goDeposit: '입금하러 가기',
  goLogin: '로그인하려면 애플리케이션 플랫폼으로 이동하세요.',
  giinTaxNo: 'GIIN 세금 번호',
  guestForbidden: '게스트 로그인 비활성화',
  givenNameEn: '영문 이름',
  greaterThan: '{number}보다 큼',
  greaterThanZero: '제로보다 큼',
  gatewayLoginUsername: '게이트웨이 로그인 사용자 이름',
  gatewayFeeAmount: 'Gateway Estimate Fee',

  /* H */
  hide: '숨기기',
  help: '도움말',
  hours: '시간',
  hasRemainingAmount: '남은 금액이 있음',

  /* I */
  id: 'ID',
  it: '기관',
  itId: '기관 ID',
  items: '개',
  itName: '기관 이름',
  inviter: '추천인',
  identity: '신분',
  itReceive: '입금 계좌',
  invalidUrl: '유효하지 않은 URL',
  inputAmount: '금액 입력',
  inputPaymentInfo: '결제 정보 입력',
  inputPaymentMethod: '금액 예측',
  itReceiveAccount: '기관 수신 계정',
  itReceiveId: '기관 수신 계정 ID',
  internetUser: '인터넷 사용자',
  institutionId: '기관 ID',
  identifyDetail: '신분 인증',
  identification: '신분',
  identityVerify: '신분 확인',
  itReceiveMethod: '기관 수신 방법',
  itReceiveNumber: '기관 수신 계좌',
  identificationId: '신분 ID',
  identificationType: 'ID 유형',
  identificationInfo: '신분 정보',
  identificationNumber: 'ID 번호',
  identificationStep1Title: '개인 정보',
  identificationStep1Name: '신분증에 나타난 이름(영문)을 입력하세요',
  identificationStep2OnlyTaxInCountry: '나는 위에 언급된 국가에서만 세금을 낸다.',
  identificationStep2SameBirthNationality: '내 출생지와 국적이 위에 언급된 국가와 동일하다.',
  identificationStep2NonUSResident: '나는 미국 시민이 아니며 미국 세금 납세자가 아니다.',
  identificationStep4Title: '투자 지식',
  identificationStep4Desc:
    '금융 상품에 대한 이해 수준을 평가해야 합니다. 제공한 답변이 정확하지 않으면 평가에 불합격할 수 있으므로 신중하게 생각해 보십시오.',
  identificationStep4KlMaxInvestment:
    '당신은 $3,000을 투자했습니다. 레버리지 비율은 1:100입니다. (레버리지를 사용한 후) 당신이 가질 수 있는 최대 포지션 가치는 얼마입니까?',
  identificationStep4KlTrigger: '손절 주문이 실행되는 경우:',
  identificationStep4KlAutoClose: '나의 미결 포지션은 자동으로 닫힐 수 있습니다. (예: 추가 마진)',
  identificationStep5Title1: '적합성 평가',
  identificationStep5Title2: '거래 경험',
  identificationStep5Desc:
    '금융 상품에 대한 이해 수준을 평가해야 합니다. 제공한 답변이 정확하지 않으면 평가에 불합격할 수 있으므로 신중하게 생각해 보십시오.',
  identificationStep5AxTradingCount: '지난 1년 동안 어떤 거래 경험이 있으십니까? (전문 자문 제외) 주식, 채권, 상품',
  identificationStep5AxOtcCount: 'OTC(장외) 파생 상품(레버리지 CFD, 외환, 차액 계약, 스프레드 베팅) 거래 경험이 어떻게 되십니까?',
  identificationStep5AxOtcLeverage: '일반적으로 위에 언급된 OTC 파생 상품 거래에 사용되는 레버리지는 얼마입니까?',
  identificationStep6Title: '전문 경험',
  identificationStep6ExpHasFinanceEducation:
    '지난 3년 동안 금융 서비스 업종에서 교육, 전문 자격 또는 근무 경험이 있습니까? (레버리지 거래를 이해해야 하는 직무 포함)',
  identificationStep6ExpFinanceEducation:
    '교육, 전문 자격 및/또는 금융 서비스 업종 근무 경험에 대한 자세한 정보를 제공해 주세요.',
  identificationStep7Title: '직업 정보',
  identificationStep7Occupation: '귀하의 현재 직장 상태는 어떻게 되십니까?',
  identificationStep7Industry: '어떤 산업 분야에서 근무하십니까?',
  identificationStep8Title: '재정 정보',
  identificationStep8finAnnualIncome: '연간 소득',
  identificationStep8finSavingsInvestment: '저축 및 투자(부동산 제외)',
  identificationStep8finIncomeSource: '거래 자금의 주요 원천은 무엇입니까?',
  identificationStep8maxInvestmentLoss: '매년 손실위험을 부담할 수 있는 대략적인 거래금액은 얼마입니까?',
  identificationStep9Title: '거래 개요',
  identificationStep9TradingFrequency: '거래 빈도는 어떻게 예상하십니까?',
  identificationStep9DepositMethod: '계정에 자금을 입금할 방법은 무엇입니까?',
  identificationStep9AcknowledgeTradingRisk:
    '{name} 거래의 본질이 각종 기초 자산의 차액 계약 상품을 사고 팔기이며, 이것이 모든 사람에게 적합하지 않다는 점을 이해하고 인정합니다. 레버리지 거래에 대한 고위험 투자입니다.',
  identificationStep10Title: '약관 및 조건',
  identificationStep10ConsentAgreement: '{name} 사용 약관을 자세히 읽었으며 동의합니다.',
  identificationStep10Agreement1: '요약 주문 실행 정책',
  identificationStep10Agreement2: '위험 공개 공지',
  identificationStep10Agreement3: '웹사이트 및 플랫폼 개인정보 보호정책',
  identificationStep10Agreement4: '주요 정보 문서',
  isExclusive: 'Is Exclusive',
  ios: 'IOS',
  iosLink: 'IOS Link',
  ifsc: 'IFSC키',

  /* J */
  jurisdiction: '사법 관할권',

  /* K */
  kv: '트레이딩 시스템 레코드 버전',
  key: '키',

  /* L */
  list: '목록',
  lock: '잠금',
  line1: '주소1',
  line2: '주소2',
  login: '로그인',
  logout: '로그아웃',
  locked: '잠김',
  loginId: '로그인 ID',
  language: '언어',
  lockTime: 'Lock Time',
  liveSystem: '라이브 시스템',
  loginQuick: '빠른 로그인',
  loginUsername: '이메일을 입력하세요',
  loginPassword: '비밀번호를 입력하세요',
  lastModifiedBy: '최종 수정자',
  lastModifiedDate: '업데이트 날짜',
  lastAutoSyncTime: '자동 동기화 시간',
  lookBackInterval: '회고 간격',
  localDepositAmount: '입금 금액 (현지 통화)',

  /* M */
  mark: '표시',
  more: '더 보기',
  mobile: '휴대전화',
  minute: '분',
  minutes: '분',
  merchantName: '상점 이름',
  middleNameEn: '중간 이름',
  mobileDetail: '휴대전화',
  manualRefresh: '수동 새로고침',
  myReceiveAccount: '내 수신 계좌',
  myReceiveBank: '내 수신 은행',
  myReceiveNumber: '내 수신 계정',
  maxAutoConfirmAmount: '최대 자동 확인 금액',
  minTransactionAmount: '최소 거래 금액',
  maxTransactionAmount: '최대 거래 금액',
  macX86Desktop: 'Mac(x86) Desktop',
  macX86DesktopLink: 'Mac(x86) Desktop Link',
  macArmDesktop: 'Mac(Arm) Desktop',
  macArmDesktopLink: 'Mac(Arm) Desktop Link',

  /* N */
  no: '아니요',
  name: '이름',
  number: '계정 번호',
  notEnabled: '비활성화됨',
  notifyLang: '알림 언어',
  notNecessary: '필요하지 않음',
  networkUrls: '네트워크 URL',
  newPassword: '새 비밀번호',
  neverExpire: '만료 없음',
  noDataFound: '데이터 없음',
  notifyEmail: '알림 이메일',
  nextStep: '다음 단계',
  noAccount: '계정 없음?',
  noTransactionHint: '거래 기록이 없습니다. 기다려 주세요.',
  noAvailableChannel: '사용 가능한 채널이 없습니다. 나중에 다시 시도하세요.',

  /* O */
  on: '켜기',
  or: '또는',
  off: '끄기',
  operator: '운영자',
  oldPassword: '이전 비밀번호',

  /* P */
  px: '픽셀',
  proof: '증명',
  people: '사람',
  profile: '프로필',
  process: '프로세스',
  payType: '결제 유형',
  pageSize: '페이지 크기',
  province: '도',
  password: '비밀번호',
  postCode: '우편번호',
  processed: '처리됨',
  processes: '프로세스',
  profession: '직업',
  plzRelogin: '다시 로그인하세요',
  phoneDetail: '일반 전화',
  parentAgent: '상위 에이전트',
  preconditions: '사전 조건',
  paymentChannel: '결제 채널',
  paymentGateway: '결제 게이트웨이',
  paymentRouting: '결제 라우팅',
  processComplete: '처리 완료',
  paymentRoutingId: '결제 라우팅 ID',
  passwordResetNoticeTitle: '비밀번호 재설정 완료',
  passwordResetFailTitle: '리디렉션',
  paymentCurrency: '결제 통화',
  pleaseChooseItReceiveAccount: '수령 방법을 선택하십시오',
  pleaseChoosePayment: '지불 방법 선택',
  pleaseSignIn: '사용자 이름과 암호를 입력하십시오',
  pleaseSignUp: '등록할 사용자 이름과 암호를 입력하십시오',
  pleaseVerifySoon: '빠른 인증을 완료하십시오',
  previousStep: '이전 단계',
  planDepositAmount: '예상 입금 금액',
  paymentFeeModel: '상위 수수료 모델',
  paymentFeeValue: '상위 수수료 값',
  paymentFeeCurrency: '상위 수수료 통화',
  plzReloginWithNewPwd: '새 암호로 다시 로그인하십시오',
  paymentFeeInfo: '상위 수수료 정보',
  paymentOrderStatus: '결제 주문 상태',
  providerType: '제공자 유형',
  pleaseSelectApprovalStatus: 'Please select approvalStatus',
  paymentFeeAmount: 'Payment Estimate Fee',
  processing: 'Processing',
  pixType: 'PIX 유형',
  pixKey: 'PIX 키',

  /* Q */
  qrCode: 'QR 코드',
  quoteCurrency: '견적 통화',

  /* R */
  rate: '환율',
  role: '역할',
  roles: '역할',
  reset: '초기화',
  region: '지역',
  result: '결과',
  roleId: '역할',
  remove: '제거',
  reject: '거부',
  reason: '이유',
  receive: '수령',
  refresh: '새로 고침',
  retract: '철회',
  regDate: '등록 날짜',
  register: '등록',
  receiver: '수신자',
  resource: '자원',
  retryMail: '메일 다시 시도',
  resend: '재전송',
  receiverId: '수신자',
  refreshAll: '모두 새로 고침',
  regCustomer: '계정 등록',
  rateDetails: '환율 상세 정보',
  receiverName: '수신자 이름',
  receiverRole: '수신자 역할',
  receiveMethod: '수령 방법',
  receiveNumber: '계좌 번호',
  receiverNumberCpf: '계좌 번호',
  receiverNumberPhone: '전화 번호',
  receiverNumberEmail: '이메일',
  receiverNumberEvp: '가상 결제 주소',
  resetPassword: '비밀번호 재설정',
  receiverNumber: '수신자 계좌 번호',
  receiverAccount: '수신 계정',
  receiveCurrency: '수령 통화',
  receiverNetwork: '수신 네트워크',
  remainingAmount: '잔액',
  recoverPassword: '비밀번호 복구',
  receivingCurrency: '수령 통화',
  registerNoAgentAlert: '대리인에게 등록 링크를 얻으십시오',
  registerNoticeTitle: '이메일을 확인하여 계정을 활성화하십시오',
  registerVerifyTitle1: '등록 성공!',
  registerVerifyTitle2: '다시',
  resendActiveMail: '활성화 이메일 다시 보내기',
  recoverMailPassword: '비밀번호를 복구하려면 이메일을 입력하십시오',
  recoverPhonePassword: '비밀번호를 복구하려면 휴대폰 번호를 입력하세요',
  restoreDefaultSettings: '기본 설정 복원',
  receiverNumberOrAddress: '수신자 계좌 번호 / 주소',
  registerOtherWay: '또는 다음 방법을 사용하여 등록하십시오',
  registerAgreementTitle1: '동의합니다',
  registerAgreementTitle2: '이용자 동의서',
  registerPleaseAgree: '동의서에 동의하세요',

  /* S */
  sex: '성별',
  show: '표시',
  step: '단계',
  sync: '동기화',
  send: '보내기',
  synced: '동기화됨',
  source: '출처',
  status: '상태',
  search: '검색',
  sender: '보낸 사람',
  social: '소셜',
  signUp: '가입',
  stopHinting: '더 이상 힌트하지 않음',
  submit: '제출',
  setting: '설정',
  success: '성공',
  settings: '설정',
  senderId: '보낸 사람',
  secretKey: '비밀 키',
  selectAll: '모두 선택',
  superUser: '슈퍼 사용자',
  shortName: '닉네임',
  searchKey: '검색어',
  shareCode: '공유 코드',
  subAgents: '하위 대리인',
  syncAgent: '대리인 동기화',
  senderRole: '보낸 사람 역할',
  signedDate: '서명 날짜',
  socialDetail: '소셜',
  signedStatus: '서명 상태',
  successMin: '최소 성공 개수',
  systemConfig: '시스템 설정',
  selectedCount: '선택한 항목 ({count})',
  systemFeeModel: '시스템 수수료 모델',
  systemFeeValue: '시스템 수수료 값',
  syncInstitution: '기관 동기화',
  settlementCurrency: '결제 통화',
  statusInfo: 'Status Info',

  /* T */
  tw: '중국어 (번체)',
  tabs: '탭',
  type: '유형',
  table: '표',
  token: '토큰',
  total: '총액',
  target: '대상',
  taxNo: '세금 번호',
  txHash: '거래 해시',
  toRefId: '고객 수령 계좌 ID',
  tabLimit: '탭 제한',
  transfer: '이체',
  tinTaxNo: 'TIN 세금 번호',
  toRefBank: '고객 수령 은행',
  testNetwork: '테스트 네트워크',
  tax: '세금',
  taxDetail: '세금 정보',
  taxFormType: '세금 양식 유형',
  taxFormDate: '세금 양식 날짜',
  taxNoExpireDate: '세금 번호 만료일',
  transaction: '거래',
  transactionProof: '거래 증명',
  tronScanUrl: 'Tron Scan URL',
  toRefNumber: '고객 수령 계좌 번호',
  timedRefresh: '타이머 새로 고침',
  tokenExpired: '로그인 만료',
  transferAmount: '이체 금액',
  transferFromIt: '기관에서 이체',
  tradingPassword: '거래 비밀번호',
  transferConfirm: '수령',
  transferDetails: '이체 세부 정보',
  transactionModel: '지불 모드',
  transactedAmount: '인출된 금액',
  transactionCategory: '지불 방법',
  transferNotifyTimeLimit: '이체 알림 시간 제한',

  /* U */
  userId: '사용자 ID',
  upload: '업로드',
  unitCny: '원',
  username: '사용자 이름',
  unlocked: '잠금 해제됨',
  unverify: '미인증',
  unchecked: '선택되지 않음',
  unprocess: '미인증',
  uncreated: '미생성',
  unapprove: '미승인',
  usCitizen: '미국 시민 여부',
  usResident: '미국 거주자 여부',
  usTaxPayers: '미국 세금 납부자 여부',
  usdFeeAmount: 'System Fee',
  usBeneficiary: '미국 수혜자 여부',
  usCompany: '미국 회사 여부',
  unprocessed: '미처리',
  unactivated: '미활성화',
  uploadImage: '이미지 업로드',
  uploadProof: '증명서 업로드',
  uploadLimitation: '{types} 최대 {maxSize}M',
  upstreamPaymentChannel: '상위 지불 채널',
  unsupportedBrowserTitle: '이 브라우저는 지원되지 않습니다.',
  unsupportedBrowserContent1: '최신 브라우저로 업그레이드하십시오.',
  unsupportedBrowserContent2: '(권장: Chrome 90+, Safari 14+, Firefox 80+)',

  /* V */
  value: '값',
  verify: '인증',
  verify2: '승인',
  version: '버전',
  validUrl: '유효한 URL',
  verified: '인증됨',
  verifyId: '인증 ID',
  verifyInfo: '인증 정보',
  verifyName: '인증 이름',
  verifyApproval: '인증 승인',
  visibilityHeight: '가시성 높이',

  /* W */
  welcome: '환영합니다',
  withdraw: '인출',
  withdrawHistory: '출금 내역',
  workflow: '워크플로우',
  withdrawal: '출금',
  waiverType: '면제 유형',
  withdrawalVerify: '출금 승인',
  withdrawalAmount: '인출 금액',
  withdrawalAmountLocal: '인출 금액 (로컬)',
  withdrawApproval: '인출 승인',
  withdrawalDetail: '인출 세부 정보',
  withdrawalFlowId: '인출 ID',
  withdrawalInfo: 'Withdrawal Info',
  windowsDesktop: 'Windows Desktop',
  windowsDesktopLink: 'Windows Desktop Link',
  web: 'Web Trader',
  webLink: 'Web Trader Link',

  /* X */

  /* Y */
  yes: '예',
  youWillTransferForAboveAccountsSeparately: '위의 계정에 개별로 이체하게 됩니다',

  /* Z */
  cn: '중국어 (간체)',

  receiverInfo: '수취인 정보',
  surName: '성',
  givName: '이름',
  middleName: '중간 이름',
  otherName: '다른 언어 이름',
  address: '주소',
  area: '휴대전화 지역번호',
  phone: '전화 번호',
  cellphone: '전화 번호',
  nationality: '국적',
  idType: '문서 유형',
  idNumber: 'ID 번호',
  locationId: '위치 ID',
  bankId: '은행 지점 번호',
  bankName: '은행 지점 이름',
  bankBranchName: '지점 이름',
  bankBranchCode: '지점 코드',
  bankBranchId: '지점 ID',
  accountNo: '은행 카드 번호',
  occupation: '직업',
  bankMobile: '은행에 예약된 휴대폰 번호',
  issueDate: '서류 발급일',
  expireDate: '문서 만료일',
  licIssuAutho: '문서 발급 기관',
  remark: '비고',
  accountType: '계정 유형',
  city: '도시',
  states: '주',
  zipCode: '우편번호',
  country: '국가',
  email: '이메일',
  accountNumber: '계좌 번호',
  phoneCountry: '휴대폰 번호 국가',
  accountCity: '계정이 속한 도시',
  accountCountry: '계정 국가',
  currency: '통화',
  userName: '사용자 이름',
  birthday: '생년월일',
  postalCode: '우편번호',
  provinceState: '주/도',
  cardNumber: '카드 번호',
  nativeFirstName: '원래 성',
  nativeLastName: '원래 이름',
  remitterType: '결제 유형',
  ibanNo: '국제 은행 계좌 번호',
  accountAddress: '계정 주소',
  routingType: '라우팅 유형',
  senderBusiness: '결제회사 정보',
  registeredName: '회사 등록명',
  tradingName: '회사 이름',
  msisdn: '회사 연락처',
  registrationNumber: '회사 등록 번호',
  dateOfIncorporation: '회사 등록일',
  purposeOfRemittance: '송금 목적',
  documentReferenceNumber: '문서 참조 번호',
  taxId: '세금 ID',
  sourceOfFund: '자금 출처',
  countryCode: '국가 코드',
  transactionType: '거래 모드',
  channelCode: '채널 번호',
  beneficiaryRelationShip: '송금관계',
  gender: '성별',
  otherDownloads: '기타 다운로드 방법',
  verifyNotice1: '이메일 확인이 완료되었습니다! ',
  verifyNotice2:
    '저희 제품---{name}에 등록해 주셔서 감사합니다. 이제 이 계정을 사용하여 로그인 인터페이스에 로그인할 수 있습니다. 궁금한 점이 있으시면 https://wa.me/13234169593로 언제든지 고객 서비스 팀에 문의해 주세요.',
  verifyNotice3: '잘 활용하시길 바랍니다 !',
  depositButtonLabel: 'PIX',
  depositNotice1: '제시:',
  depositNotice2: ' 첫 번째 리필 시',
  depositNotice3: '{amount} {currency}',
  depositNotice4: '플랫폼은 다음과 같은 추가 보너스를 제공합니다',
  depositNotice5: ' {amount} {currency}',
  depositNotice6: '입금과 출금 환율은 동일합니다',
  liveRoom: '생방송을 보면서 어떻게 돈 버는 것을 배우나요',
  emailPassword: '이메일',
  phonePassword: '전화번호',
  globalName: 'ASTRAL',

  cryptoTokenType: '블록체인 네트워크',
  cryptoWalletAddress: '지갑 주소',
};
